import {
  DashboardChartBarDataType,
  EDashboardChartRange,
  EDashboardTabType,
  IDashboardDetailsChartBarData,
  IDashboardSingleChartBarData,
} from '../types/eecs-dashboard.types';

export const DashboardTabTypeMap = {
  [EDashboardTabType.SPOT]: { name: 'Spot', isHidden: false },
  [EDashboardTabType.FORWARD]: { name: 'Forward', isHidden: false },
  [EDashboardTabType.REVENUE_EXPENSE]: { name: 'Revenue & Expense', isHidden: false },
  [EDashboardTabType.PREDICTIONS]: { name: 'Predictions', isHidden: true },
};

export const DashboardChartRangeMap = {
  [EDashboardChartRange.WEEK]: { name: '1W' },
  [EDashboardChartRange.MONTH]: { name: '1M' },
  [EDashboardChartRange.SIX_MONTHS]: { name: '6M' },
  [EDashboardChartRange.YEAR]: { name: '1Y' },
};

export const revenueExpenseSpotDefaultData: IDashboardSingleChartBarData = {
  type: DashboardChartBarDataType.SPOT,
  firstVolume: 0,
  firstVolumeTitle: 'Spot',
  firstVolumeColor: 'rgba(106, 178, 239, 0.1)',
  firstVolumeBorderColor: 'rgba(106, 178, 239, 1)',
  firstVolumeFilterValue: 'spot',
};

export const revenueExpenseForwardDefaultData: IDashboardSingleChartBarData = {
  type: DashboardChartBarDataType.FORWARD,
  firstVolume: 0,
  firstVolumeTitle: 'Forward',
  firstVolumeColor: 'rgba(42, 200, 200, 0.1)',
  firstVolumeBorderColor: 'rgba(42, 200, 200, 1)',
  firstVolumeFilterValue: 'forward',
};

export const detailsAIBDefaultData: IDashboardDetailsChartBarData = {
  type: DashboardChartBarDataType.AIB_GRID_CONNECTED,
  firstVolume: 0,
  firstVolumeTitle: 'Yes',
  firstVolumeColor: 'rgba(226, 247, 90, 0.08)',
  firstVolumeBorderColor: 'rgba(226, 247, 90, 1)',
  firstVolumeFilterValue: '1',

  secondVolume: 0,
  secondVolumeTitle: 'No',
  secondVolumeColor: 'rgba(106, 126, 239, 0.08)',
  secondVolumeBorderColor: 'rgba(106, 126, 239, 1)',
  secondVolumeFilterValue: '0',
};

export const detailsTypeOfSupportDefaultData: IDashboardDetailsChartBarData = {
  type: DashboardChartBarDataType.TYPE_OF_SUPPORT,
  firstVolume: 0,
  firstVolumeColor: 'rgba(207, 230, 249, 0.08)',
  firstVolumeBorderColor: 'rgba(207, 230, 249, 1)',
  firstVolumeTitle: 'No Support',
  firstVolumeFilterValue: 'no_support',

  secondVolume: 0,
  secondVolumeTitle: 'Production',
  secondVolumeColor: 'rgba(42, 200, 200, 0.08)',
  secondVolumeBorderColor: 'rgba(42, 200, 200, 1)',
  secondVolumeFilterValue: 'production',
};

export const dashboardColors = [
  '#FAFBD1',
  '#FE4E45',
  '#27DFCC',
  '#FF8A14',
  '#00F77B',
  '#ACABAB',
  '#3385F8',
  '#61D1FD',
  '#F3FF0A',
  '#C3E17E',
  '#A0FFE4',
  '#DB79FF',
  '#9232F8',
];
